import { defineComponent as _defineComponent } from 'vue'
import BlogArticle from '@/views/blog/pages/BlogArticle.vue';
import PublicBlogPage from './PublicBlogPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicBlogArticle',
  props: {
    articleId: null
  },
  setup(__props: any) {



return { __sfc: true,BlogArticle, PublicBlogPage }
}

})